<template>
  <quill-editor
    v-model="content"
    ref="myQuillEditor"
    :options="editorOption"
    @blur="onEditorBlur($event)"
    @focus="onEditorFocus($event)"
    @change="onEditorChange($event)"
    @ready="onEditorReady($event)"
  ></quill-editor>
</template>

<script>
import { quillEditor } from 'vue-quill-editor';

import 'quill/dist/quill.core.css';
import 'quill/dist/quill.snow.css';
import 'quill/dist/quill.bubble.css';

export default {
  components: {
    quillEditor,
  },

  props: {
    defaultContent: {
      type: String,
      default: 'I am Example',
    },
  },

  watch: {
    defaultContent: function(newVal) {
      this.content = newVal;
    },
  },

  data() {
    return {
      content: this.defaultContent,
      editorOption: {},
    };
  },

  methods: {
    onEditorBlur(quill) {
      console.log('editor blur!', quill);
      this.$emit('onChange', this.content);
    },
    onEditorFocus(quill) {
      console.log('editor focus!', quill);
    },
    onEditorReady(quill) {
      console.log('editor ready!', quill);
    },
    onEditorChange({ quill, html, text }) {
      this.content = html;
      this.$emit('onChange', html);
    },
  },

  computed: {
    editor() {
      return this.$refs.myQuillEditor.quill;
    },
  },

  mounted() {
    this.$emit('onChange', this.content);
  },
};
</script>

<style></style>



// WEBPACK FOOTER //
// src/components/parseEdit.vue